import Button from '@passkeys/ui/button';
import SegmentedControl from '@passkeys/ui/segmented-control';
import Text from '@passkeys/ui/text';
import { useSelector } from 'react-redux';

import type { Asset } from '@/types';
import selectors from '@/ui/flux/selectors';

interface CurrencySelectorProps {
  fiatMode: boolean;
  configFiat: any;
  asset: Asset;
  onAllClick: () => void;
  onChange: (fiatMode: boolean) => void;
}

function CurrencySelector({
  fiatMode,
  configFiat,
  asset,
  onAllClick,
  onChange,
}: CurrencySelectorProps) {
  const ratesLoading = useSelector(selectors.rates.loading) as boolean;

  return (
    <div className="flex items-center gap-2">
      {ratesLoading && <Text>{asset.displayTicker}</Text>}

      {!ratesLoading && (
        <SegmentedControl
          size="small"
          activeIndex={fiatMode ? 0 : 1}
          segments={[
            {
              label: configFiat.defaultUnit(0).unitName,
              onClick: () => onChange(true),
            },
            {
              label: asset.displayTicker,
              onClick: () => onChange(false),
            },
          ]}
        />
      )}

      <Button size="small" dataTestId="full-amount-button" onClick={onAllClick}>
        All
      </Button>
    </div>
  );
}

export default CurrencySelector;
